import { Component, Input, OnChanges, ViewChild , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-accepted',
    templateUrl: './application-accepted.component.html',
    styleUrls: ['./application-accepted.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationAcceptedComponent implements OnChanges {
    @Input() status: any;
    @ViewChild('paymentSlider') slides: IonSlides;

    constructor() {}

    ngOnChanges() {
        /* empty */
    }
}
